"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePhotoViewer = exports.photoViewerContext = void 0;
const react_1 = require("react");
exports.photoViewerContext = (0, react_1.createContext)({
    open: (parameters) => { },
});
const usePhotoViewer = () => {
    return (0, react_1.useContext)(exports.photoViewerContext);
};
exports.usePhotoViewer = usePhotoViewer;
//# sourceMappingURL=usePhotoViewer.js.map